<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="23"
        height="21"
        viewBox="0 0 23 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M4.11883 7.54843e-06C3.80664 1.00216e-05 3.61041 0.0665713 3.44508 0.219957L0.0971203 3.32612C0.0349457 3.3838 1.59959e-05 3.46209 1.7587e-09 3.54365C-1.86581e-05 3.71346 0.148404 3.85114 0.331438 3.85114H14.845L5.92244 12.1292C5.7466 12.2923 5.64431 12.3872 5.64432 12.7074L5.64431 14.8854C5.64432 15.0173 5.70898 15.1316 5.80177 15.2177C5.89456 15.3038 6.01763 15.3637 6.15979 15.3637H8.50752C8.8526 15.3637 8.95475 15.2689 9.13058 15.1057L18.0532 6.82759V20.293C18.0532 20.4628 18.2016 20.6005 18.3846 20.6005C18.4725 20.6004 18.5569 20.568 18.619 20.5104L21.967 17.4042C22.1323 17.2508 22.2041 17.0688 22.2041 16.7791L22.2041 2.07568C22.2041 1.80309 22.1462 1.53317 22.0337 1.28133C21.9213 1.0295 21.7565 0.800675 21.5487 0.60793C21.341 0.415185 21.0943 0.262293 20.8229 0.157985C20.5514 0.0536763 20.2605 -8.08951e-06 19.9667 9.1721e-10L4.11883 7.54843e-06Z"
            fill="currentColor"
        />
        <path
            d="M1.27385 15.9698H4.49425C4.76363 15.9698 4.9805 16.171 4.9805 16.4209V19.4274C4.9805 19.6774 4.76363 19.8786 4.49425 19.8786H1.27385C1.00447 19.8786 0.787598 19.6774 0.787598 19.4274V16.4209C0.787598 16.171 1.00447 15.9698 1.27385 15.9698Z"
            fill="currentColor"
        />
    </svg>
</template>
